<div class="section-title">
  {{config.title | translate}}
</div>
